module.exports = __webpack_public_path__ + "static/media/logo.be9be7ca.png";